import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL, ENDPOINTS } from '../../constants/api';
import { getToken } from '../../utils/TokenUtils';

const ElectionResults = () => {
  const [results, setResults] = useState({});
  const [timer, setTimer] = useState(30);
  const token = getToken();
  // Fetch results from API
  const fetchResults = async () => {
    try {
      const url = `${API_URL}/${ENDPOINTS.SYS}/getlink/election-results`;
      const response = await axios.get(url, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      });
      const grouped = groupByTitle(response.data.report); // Flat array → grouped object
      setResults(grouped);
    } catch (error) {
      console.error('Error fetching results:', error);
    }
  };
  console.log('results:', results);
  // Load results initially and every 30 seconds
  useEffect(() => {
    fetchResults();
    const interval = setInterval(() => {
      fetchResults();
      setTimer(30);
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  // Countdown timer
  useEffect(() => {
    const countdown = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(countdown);
  }, []);

  const groupByTitle = (data) => {
    const grouped = {};
    data.forEach((item) => {
      if (!grouped[item.title]) {
        grouped[item.title] = [];
      }
      grouped[item.title].push(item);
    });
    return grouped;
  };
  return (
    <div className="container mt-4">
      <h2 className="mb-4">Election Results</h2>
      <div className="alert alert-info text-center fs-5 fw-bold">
        Reloading in {timer} second{timer !== 1 ? 's' : ''}
      </div>

      {Object.entries(results).map(([title, candidates]) => {
        const colClass = candidates.length === 4 ? 'col-md-3' : 'col-md-4';

        return (
          <div key={title} className="mb-5">
            <h4 className="mb-3">{title}</h4>
            <div className="row">
              {candidates?.map((candidate) => {
                let colorClass = 'bg-secondary';
                const percent = candidate.percentage;

                if (percent <= 25) colorClass = 'bg-danger';
                else if (percent <= 50) colorClass = 'bg-warning';
                else if (percent <= 75) colorClass = 'bg-info';
                else colorClass = 'bg-success';

                return (
                  <div className={`${colClass} mb-4`} key={candidate.id}>
                    <div className="card h-100">
                      <img
                        src={`https://votingapi.kaafi.net/${candidate.image}`}
                        className="card-img-top"
                        alt={candidate.name}
                        style={{ height: '350px', objectFit: 'cover' }}
                      />
                      <div className="card-body text-center">
                        <h5 className="card-title">{candidate.name}</h5>
                        <div className="mt-3">
                          <div>
                            <strong>Total Votes:</strong> {candidate.all_votes}
                          </div>
                          <div>
                            <strong>Candidate Votes:</strong>{' '}
                            {candidate.candidate_votes}
                          </div>
                          <div>
                            <strong>Result %:</strong> {candidate.percentage}%
                          </div>
                        </div>
                      </div>
                      <div className="card-footer text-center">
                        <div className="progress" style={{ height: '25px' }}>
                          <div
                            className={`progress-bar ${colorClass}`}
                            role="progressbar"
                            style={{
                              width: `${percent}%`,
                              fontWeight: 'bold',
                              fontSize: '1rem',
                            }}
                          >
                            {percent}%
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ElectionResults;
